import './visitSelectionView.scss'
import { VisitCard } from '../../../../pages/charts/patient-chart/components/visit-card/VisitCard'
import { type PastVisit } from '../../../../types/types'
import { HeaderView } from '../header-view/HeaderView'

interface Props {
  visits: PastVisit[]
  onSelectVisit: (visit: PastVisit) => void
}

export const VisitSelectionView = ({ visits, onSelectVisit }: Props) => (
  <div className='visit-selection-view-container'>
    <HeaderView title='Add new order' />
    <div className='visit-selection-view-text-container'>Choose visit for order</div>
    <div className='visit-selection-view-body-container'>
      <div className='visit-selection-view-visit-container'>
        {visits.map((visit, index) => (
          <div
            onClick={() => onSelectVisit(visit)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                onSelectVisit(visit)
              }
            }}
            role='button'
            tabIndex={0}
            key={visit.VisitId}>
            <VisitCard
              visit={visit}
              id={`visit-visit-list${index}`}
              onClickArrowAction={() => {
                onSelectVisit(visit)
              }}
              showStatus
            />
          </div>
        ))}
      </div>
    </div>
  </div>
)
